import { OrGenericContent } from './or-generic-content';
import { IOrGenericContentCMSProps } from './or-generic-content.types';

export const OrGenericContentCMS = ({
  top_spacing,
  bottom_spacing,
  rich_text,
}: IOrGenericContentCMSProps) => {
  return (
    <OrGenericContent
      top_spacing={top_spacing.spacing_value}
      bottom_spacing={bottom_spacing.spacing_value}
      rich_text={rich_text}
    />
  );
};
